import {Injectable, inject} from '@angular/core';
import {Subject} from 'rxjs';
import {ApiLanguageService} from '../../../api/common-feature/api-language/api-language.service';
import {AppTranslateService} from '../translate/app-translate/app-translate.service';
import {OidcAuthService} from '../../../auth/oidc-auth/oidc-auth.service';
import {Language} from '../../../../../common/enums/language.enum';
import {ErrorService} from '../../error/error/error.service';

@Injectable({
  providedIn: 'root',
})
export class LangService {

  private apiLanguageService = inject(ApiLanguageService);

  private errorService = inject(ErrorService);

  private oidcAuthService = inject(OidcAuthService);

  private appTranslateService = inject(AppTranslateService);

  public updateLangAfterUpdateTokenSubject: Subject<any> = new Subject<any>();

  public startedUpdateLangTokenSubject: Subject<any> = new Subject<any>();

  public updateSharedLinkLanguageSubject: Subject<string> = new Subject<string>();

  /**
   * Method: Update language in application by language
   * @param language
   */
  public updateLanguage(language: string): any {
    this.startedUpdateLangTokenSubject.next(true);
    return this.apiLanguageService
      .updateLanguageObservable(language)
      .subscribe(
        {
          next: async () => {
            await this.oidcAuthService.renewToken();
            this.updateLangAfterUpdateTokenSubject.next(true);
          },
          error: err => {
            this.errorService.showGraphQLErrors(err);
          },
        },
      );
  }

  /**
   * Method: Update language for iframe module
   * @param language
   */
  public updateLanguageInIframe(language: string): void {
    const update = !!language;
    this.updateLangAfterUpdateTokenSubject.next(update);
  }

  /**
   * Method: Make event change language for shared link page
   * @param lang
   */
  public updateSharedLinkLanguage(lang: string): void {
    this.updateSharedLinkLanguageSubject.next(lang);
  }

  /**
   * Method: Get current app language uppercased (e.g. 'DE'), falling back to German
   */
  public getCurrentLangUppercase(): string {
    const lang = this.appTranslateService.getCurrentAppLanguage() || Language.de;
    return lang.toUpperCase();
  }

}
